<template>
  <el-container>
    <el-main>
      <el-row :gutter="18">
        <el-col :span="4">
          <h2>
            Total Usuarios:
            <span>{{ TotalUsuarios }}</span>
          </h2>
        </el-col>
        <el-col :span="4">
          <h2>
            Total Usuarios Activos:
            <span class="green">{{ TotalActiveUsers }}</span>
          </h2>
        </el-col>
        <el-col :span="4">
          <h2>
            Total Usuarios Inactivos:
            <span class="red">{{ TotalInactiveUsers }}</span>
          </h2>
        </el-col>
        <el-col :span="4">
          <h2>
            Total Equipos:
            <span>{{ TotalTrackers }}</span>
          </h2>
        </el-col>
        <el-col :span="4">
          <h2>
            Total Equipos Activos:
            <span class="green">{{ TotalActiveTrackers }}</span>
          </h2>
        </el-col>
        <el-col :span="4">
          <h2>
            Total Equipos Inactivos:
            <span class="red">{{ TotalInactiveTrackers }}</span>
          </h2>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "cardDrawerHeaderUserNoContract",
  props: {
    Data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      TotalUsuarios: 0,
      TotalActiveUsers: 0,
      TotalInactiveUsers: 0,
      TotalTrackers: 0,
      TotalActiveTrackers: 0,
      TotalInactiveTrackers: 0
    };
  },
  mounted() {
    this.GetData();
  },
  computed: {
    ...mapGetters({
      getTrackers: "navixy/getTrackers"
    })
  },
  methods: {
    GetData() {
      var data = this.$store.getters["navixy/getUserList"];
      this.TotalUsuarios = data.length;
      this.TotalActiveUsers = data.filter(
        (user) => user.activated === true
      ).length;
      this.TotalInactiveUsers = data.filter(
        (user) => user.activated === false
      ).length;
      this.TotalTrackers = this.getTrackers.length;
      this.TotalActiveTrackers = this.getTrackers.filter(
        (tracker) =>
          tracker.source.connection_status === "active" &&
          tracker.source.blocked === false
      ).length;
      this.TotalInactiveTrackers = this.getTrackers.filter(
        (tracker) =>
          tracker.source.connection_status !== "active" &&
          tracker.source.blocked === false
      ).length;
    }
  },
  watch: {
    data(data) {
      console.log("sdsdsd" + data);
      this.TotalUsuarios = data.length;
      this.TotalActiveUsers = data.filter(
        (user) => user.activated === true
      ).length;
      this.TotalInactiveUsers = data.filter(
        (user) => user.activated === false
      ).length;
      this.TotalTrackers = this.getTrackers.length;
      this.TotalActiveTrackers = this.getTrackers.filter(
        (tracker) =>
          tracker.source.connection_status === "active" &&
          tracker.source.blocked === false
      ).length;
      this.TotalInactiveTrackers = this.getTrackers.filter(
        (tracker) =>
          tracker.source.connection_status !== "active" &&
          tracker.source.blocked === false
      ).length;
    }
  }
};
</script>
<style scoped>
h2 {
  text-align: left;
  font-size: 20px;
  color: rgb(96, 100, 100);
}
.red {
  color: rgb(255, 0, 0);
}
.green {
  color: rgb(1, 194, 1);
}
</style>
